<template>
  <CreateCollaboratorModal
    v-if="showCreateCollaboratorModal"
    :projectId="projectId"
    @closeModal="closeModal"
  />
  <DeleteCollaboratorModal
    v-if="showDeleteCollaboratorModal"
    :projectId="projectId"
    :projectCollaboratorId="projectCollaboratorIdSelected"
    @closeModal="closeModal"
  />
  <LoadingData v-if="loadData" />
  <div v-else class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h6 class="py-3 mb-0">Colaboradores</h6>
      <div
        v-if="isCollaboratorPrincipalProject && canEditProject"
        class="ms-auto"
      >
        <button
          type="button"
          class="btn btn-sm btn-primary"
          title="Adicionar Colaborador ao Sumário Executivo"
          @click="showCreateCollaboratorModal = true"
        >
          Adicionar Colaborador
        </button>
      </div>
    </div>
    <ListCollaborators
      v-if="collaborators.length > 0"
      :collaborators="collaborators"
      @deleteCollaborator="deleteCollaborator"
    />
    <div v-else class="card-body text-center">
      <p class="mb-0">
        Este sumário executivo não possui nenhum colaborador cadastrado
      </p>
    </div>
  </div>
</template>

<script>
import CreateCollaboratorModal from '@/components/projects/collaborators/CreateCollaboratorModal.vue'
import DeleteCollaboratorModal from '@/components/projects/collaborators/DeleteCollaboratorModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListCollaborators from '@/components/projects/collaborators/ListCollaborators.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CollaboratorsProject',

  components: {
    CreateCollaboratorModal,
    DeleteCollaboratorModal,
    LoadingData,
    ListCollaborators,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      loadData: true,
      showCreateCollaboratorModal: false,
      showDeleteCollaboratorModal: false,
      collaborators: [],
      projectCollaboratorIdSelected: null,
    }
  },

  computed: {
    ...mapGetters([
      'projectSelected',
      'canEditProject',
      'isCollaboratorPrincipalProject',
    ]),
  },

  methods: {
    async getCollaborators() {
      try {
        this.collaborators = await this.$store.dispatch(
          'getProjectCollaborators',
          this.projectId,
        )
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    deleteCollaborator(projectCollaboratorId) {
      this.projectCollaboratorIdSelected = projectCollaboratorId
      this.showDeleteCollaboratorModal = true
    },

    closeModal(loadListCollaborators) {
      if (loadListCollaborators) {
        this.getCollaborators()
      }
      this.showCreateCollaboratorModal = false
      this.showDeleteCollaboratorModal = false
    },
  },

  mounted() {
    this.getCollaborators()
  },
}
</script>
